// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import StarSvg from '../icons/action/Star';
var Star = createSvgIcon({
    as: StarSvg,
    ariaLabel: 'star',
    category: 'action',
    displayName: 'Star'
});
export default Star;
